import moment from 'moment'
import buildCompanyName from '../../utilities/buildCompanyName'
import {
    getProductManufacturerCode,
    getProductName,
    getProductPresentationAmount
} from '../../utilities/productDisplay'
import {
    formConsumptionVoucher,
    productsControl,
    reqProducts,
    reqStowage,
    reqWarehouse,
    reqWorkingPeriod,
    storagePage
} from './storage'
import { GETConsumerVoucher, LogicalProductForVoucher } from './types'

export default function useInitialEdition() {
    return function load(consumptionVoucher: GETConsumerVoucher) {
        const {
            company_warehouse,
            minimal_stowage,
            consumer_voucher_label,
            consumer_voucher_products,
            document
        } = consumptionVoucher

        const company = company_warehouse.company
        formConsumptionVoucher.setValue('company', {
            label: buildCompanyName(company.name),
            value: company.id.toString(),
            image: company.country.image_url
        })

        storagePage.symbol = storagePage.companies.find(
            c => c.id === company.id
        ).local_currency.symbol

        reqWarehouse.setQuery('company_id', company.id)
        reqStowage.setQuery('company_id', company.id)
        formConsumptionVoucher.setProps('company', {
            disabled: true
        })

        const warehouse = company_warehouse.warehouse
        formConsumptionVoucher.setValue('warehouse', {
            label: warehouse.name,
            value: warehouse.id.toString()
        })
        formConsumptionVoucher.setProps('warehouse', { disabled: true })
        formConsumptionVoucher.setValue(
            'request_date',
            moment(document.request_date)
                .tz(storagePage.timezone)
                .toISOString(true)
        )
        formConsumptionVoucher.setProps('request_date', { disabled: true })
        reqProducts.setQuery(
            'operation_date',
            moment(document.request_date)
                .tz(storagePage.timezone)
                .format('YYYY-MM-DD')
        )

        const stowage = minimal_stowage.stowage
        formConsumptionVoucher.setValue('stowage', {
            label: stowage.name,
            value: stowage.id.toString()
        })
        formConsumptionVoucher.setProps('stowage', { disabled: true })

        const listStowages = [2, 6, 11]

        formConsumptionVoucher.setProps('sub_stowage', { disabled: true })

        if (listStowages.includes(minimal_stowage.stowage.type_stowage_id)) {
            formConsumptionVoucher.setValue('sub_stowage', {
                value: minimal_stowage.id.toString(),
                label: minimal_stowage.order_sub_stowage.order.number
            })
        }

        formConsumptionVoucher.setValue('tag', {
            label: consumer_voucher_label.name,
            value: consumer_voucher_label.id.toString()
        })

        formConsumptionVoucher.setValue('description', document.description)

        const logicalProductForVoucher: LogicalProductForVoucher[] =
            consumer_voucher_products.map(cvp => ({
                id: cvp.id,
                logical_product_id: cvp.operation.logical_product_id,
                name: getProductName(cvp.product),
                code: getProductManufacturerCode(cvp.product),
                presentation: getProductPresentationAmount(cvp.product),
                quantity: cvp.quantity.toString(),
                stock:
                    cvp.operation.logical_product.max_quantity_to_move +
                    cvp.quantity,
                average: cvp.operation.average_unit_cost,
                total: cvp.quantity * cvp.operation.average_unit_cost
            }))
        storagePage.current_consumer_voucher_products =
            consumer_voucher_products.filter(
                cvp => cvp.is_enabled && !cvp.deleted
            )
        productsControl.setList(logicalProductForVoucher)
        const options = logicalProductForVoucher.map(lpfv => ({
            label: lpfv.name,
            value: lpfv.logical_product_id.toString()
        }))
        formConsumptionVoucher.setValue('products', options)
        formConsumptionVoucher.setProps('products', { disabled: false })
        reqWorkingPeriod.setParam('company_id', company.id)
        reqProducts.setQuery('origin_minimal_stowage_id', minimal_stowage.id)
        reqProducts.setQuery(
            'not_logical_product_ids',
            options.map(option => option.value)
        )
    }
}
